import React, { memo, useState } from "react"
import CardHeader from "../../components/CardHeader"
import TestimonialsList from "../../components/TestmonialsList"
import LogosBanner from "../../components/LogosBanner"
import { ButtonClose } from "../../components/ChatCloseButton"
import EvaluationCard from "../../components/EvaluationCard"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { InteractionChart, RankingChart } from "../../components/AssistanceDetailsCharts"
import "./styles.scss"
import BurnedContainer from "../../container/BurnedContainer"
import { EscalaLabel } from "../../components/EscaleBar"
import { BulletTabs } from "../../components/BulletTabs"
import { ContentListItem, ProducerListItem } from "../../components/ContentList"
import { ProgressBar } from "../../components/ProgressBar"
import { PickerWithType } from "../../components/DatePicker"
import { Button, ButtonLoader } from "../../components/Button"
import CustomTreeSelect from "../../components/TreeSelect"
import { Input, SelectInput } from "../../components/Form"
import { InfoTooltip } from "../../components/Tooltip"
import { VariableSizeList as List } from "react-window"
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Label,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import { ChatIcon } from "../../components/ImageComponents"
import { formatNumber } from "../../core/utils/formatNumber"
import { exportAssistanceTable, exportContentSent } from "../../core/utils/exports"
import { IoFilterOutline } from "react-icons/io5"
import Overlay from "../../components/Overlay"

const IndexESMCard = ({ counter = 0, percentage = 0, description, cardName }) => {
  return (
    <div className={`index-card-grid__counter ${cardName ? cardName : ""}`}>
      <span className="index-card-grid__counter-description">{description}</span>
      <div className="index-card-percentage-div">
        <span className="index-card-grid__counter-number">{counter}</span>
        <span className="index-card-grid__counter-percentage">{percentage}</span>
      </div>
    </div>
  )
}

const JourneyCard = ({ counter = 0, description, cardName, isLoading = false }) => {
  return (
    <div className={`journey-card-grid__counter ${cardName ? cardName : ""}`}>
      {isLoading ? (
        <>
          <div className="skeleton skeleton-number"></div>
          <div className="skeleton skeleton-text"></div>
        </>
      ) : (
        <>
          <span className="journey-card-grid__counter-number">{counter}</span>
          <span className="journey-card-grid__counter-description">{description}</span>
        </>
      )}
    </div>
  )
}

const CardDetailsCount = ({
  nameCard = "assistance",
  handleOpenDetails = () => { },
  description = "",
  icon,
  counter = 0,
}) => {
  return (
    <div
      className={`card-middle-details card-middle-details__${nameCard}`}
      onClick={counter > 0 ? handleOpenDetails : () => { }}>
      <div className="card-details">
        <div className="card-details__top">
          <div className={`card-details-icon icon-${nameCard}`}>
            <i className={`fi ${icon}`} />
          </div>
          {counter > 0 && (
            <div className="card-middle-action">
              <i class="fi fi-sr-angle-small-right"></i>
            </div>
          )}
        </div>
        <div className="card-details__bottom" title={`${counter} ${description}`}>
          <span className="card-details__bottom-counter">{counter}</span>
          <span className={`card-details__bottom-description`}>{description}</span>
        </div>
      </div>
    </div>
  )
}

const CardDetailsGeolocation = ({
  handleOpenDetails = () => { },
  description = "",
  counter = 0,
}) => {
  return (
    <div className={`card-middle-details card-middle-details__geo`}>
      <BurnedContainer onlyMap />
      <div className="card-details card-details-geo">
        <div className="card-details__bottom">
          <div
            className="card-details-geo__action"
            onClick={() => handleOpenDetails()}
            role="button">
            <div
              className="card-details-geo__action-user-counter"
              title={`${counter} Beneficiários cadastrados`}>
              <i className="fi fi-sr-user" />
              <span className="user-counter">{counter}</span>
            </div>
            <span className="card-details-geo__action-user-title">Beneficiários cadastrados</span>
            <div className="card-details-geo__action-button" role="button">
              <i class="fi fi-sr-angle-small-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const AssistanceDetailsFilters = ({
  modalOpen,
  setModalOpen,
  handleAssistancesDetailsFilters,
  assistancesDetailsFilters,
  assistancesTypes,
  projectsOptions,
  allDetailsAssistancesTechnicians,
  allDetailsAssistancesUsers,
  isUserTec
}) => {
  return (
    <ModalPanel width={500} modalIsOpen={modalOpen} shouldCloseOnOverlayClick={true}>
      <ModalHeader closeModal={() => setModalOpen()} title="Filtrar" />
      <ModalBody hideScroll className="action-plan-filter-modal-body">
        <div className="action-plan-filter-fields">
          <div className="header-period">
            <PickerWithType
              onChange={(value) => handleAssistancesDetailsFilters("date", value)}
              isWhite={false}
              value={assistancesDetailsFilters?.date}
              placeholder={["Período inicial", "Período final"]}
            />
          </div>
          {projectsOptions.length > 0 &&
            <div className="header-status">
              <SelectInput
                handleChange={(value) => handleAssistancesDetailsFilters("projects", value)}
                value={assistancesDetailsFilters?.projects}
                options={projectsOptions}
                breakLine={false}
                isClearable={true}
                placeholder={"Projetos"}
                isOverModal={true}
                isMulti={true}
                isSearchable={true}
              />
            </div>}
          {!isUserTec && <div className="header-responsible">
            <SelectInput
              handleChange={(value) => handleAssistancesDetailsFilters("responsible", value)}
              value={assistancesDetailsFilters?.responsible}
              options={allDetailsAssistancesTechnicians}
              isSearchable={true}
              breakLine={false}
              isClearable={true}
              placeholder={"Responsável"}
              isOverModal={true}
            />
          </div>}
          <div className="header-users">
            <SelectInput
              handleChange={(value) => handleAssistancesDetailsFilters("producers", value)}
              value={assistancesDetailsFilters?.producers}
              options={allDetailsAssistancesUsers}
              isSearchable={true}
              breakLine={false}
              isClearable={true}
              placeholder="Produtor"
              isOverModal={true}
            />
          </div>
          <div className="header-responsible">
            <SelectInput
              handleChange={(value) => handleAssistancesDetailsFilters("assistanceType", value)}
              value={assistancesDetailsFilters?.assistanceType}
              options={assistancesTypes}
              isSearchable={true}
              breakLine={false}
              isClearable={true}
              placeholder={"Tipo de Atendimento"}
              isOverModal={true}
            />
          </div>

        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Confirmar" color="orange" handleClick={() => setModalOpen()} />
      </ModalFooter>
    </ModalPanel>
  )
}

const ProjectSummaryScreen = ({
  handleProjectsPeriodFilter,
  projectsPeriodFilter,
  projectId,
  beneficiaryJourney,
  beneficiaries,
  assistanceDetails,
  testimonials,
  handleFavoritedTestimonials,
  favoritedTestimonials,
  handleFavoriteTestimonial,
  toggleModal,
  openModal,
  isLoading,
  handleChangeTab,
  currentTab,
  contents,
  producers,
  handleChangeTecnhicianSelect,
  technicianOptions,
  dashboardEvaluation,
  isUserTec,
  isUserAdmin,
  isUserManager,
  assistanceEvaluationHistory,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  onFilterDate,
  dateFilter,
  isFavoriteRefetching,
  assistanceData,
  handleShowFilters,
  showFilters,
  assistancesTypes,
  handleAssistancesDetailsFilters,
  assistancesDetailsFilters,
  allDetailsAssistances,
  allDetailsAssistancesTechnicians,
  allDetailsAssistancesUsers,
  projectsOptions,
  isRefetching
}) => {

  const { exportContent, loading } = exportContentSent(
    currentTab === "contents" ? contents : producers,
    currentTab === "producers",
  )

  const { exportAssistance, loadingAssistanceTable } = exportAssistanceTable(
    allDetailsAssistances
  )

  const getRowHeight = (index) => {
    return 50
  }

  const Row = ({ index, style }) => {
    const item = allDetailsAssistances?.[index];

    return (
      <div className="table-row" style={style}>
        <div className="table-cell">{item?.NomeProdutor || "-"}</div>
        <div className="table-cell">{item?.data ? new Date(item.data.value).toLocaleDateString() : "-"}</div>
        <div className="table-cell">{item?.projeto || "-"}</div>
        <div className="table-cell">{item?.nomeResponsavel || "-"}</div>
        <div className="table-cell">{item?.acao || "-"}</div>
        <div className="table-cell">{item?.link || "-"}</div>
      </div>
    )
  }

  return (
    <>
      {projectId === "f19ca68e-c476-418e-94a1-5592d0c663de" && <LogosBanner />}
      <div className="project-summary-container">
        <div className="project-summary__left-card">
          <div className="project-summary__left-card-middle">
            <CardDetailsCount
              icon="fi-sr-comment"
              description="Temas abordados ao longo do projeto"
              handleOpenDetails={() => toggleModal("assistanceDetails")}
              counter={assistanceDetails && assistanceDetails.totalAssistances}
            />
            <CardDetailsCount
              icon="fi-sr-comment"
              nameCard="content"
              description="Conteúdos enviados"
              handleOpenDetails={() => toggleModal("sharedContent")}
              counter={contents?.length || 0}
            />
            <CardDetailsGeolocation
              handleOpenDetails={() => toggleModal("geolocalization")}
              counter={beneficiaries?.length || 0}
            />
          </div>
          <div className="project-summary__left-card-bottom">
            {(isUserAdmin || isUserManager || isUserTec) && (
              <div className="project-summary__header-period">
                <div className="header-period">
                  <span className="project-summary__header-period-label">Período</span>
                  <PickerWithType
                    onChange={handleProjectsPeriodFilter}
                    value={projectsPeriodFilter || ""}
                    isWhite={false}
                  />
                </div>

                {(isUserAdmin || isUserManager) && (
                  <div className="header-period">
                    <span className="project-summary__header-period-label">Técnico</span>
                    <SelectInput
                      handleChange={handleChangeTecnhicianSelect}
                      defaultValue={technicianOptions[0]}
                      isMulti
                      options={technicianOptions || []}
                      resetFields={projectId}
                      isDisabled={!technicianOptions || !projectId}
                      isSearchable={true}
                      maxHeight={50}
                      className="tecnhinican-select"
                    />
                  </div>
                )}
              </div>
            )}
            <MetricCard
              {...{
                assistanceData,
                assistanceEvaluation: dashboardEvaluation,
                isUserAdmin,
                assistanceEvaluationHistory,
              }}
            />
          </div>
          <div className="project-summary__left-card-middle2 journey-card">
            <CardHeader title="Jornada do beneficiário" className="testimonials-header" />
            <div className="journey-card-grid">
              <JourneyCard
                cardName="disconnected"
                counter={(beneficiaryJourney && beneficiaryJourney?.desconexao) || 0}
                description="Desconexão"
                isLoading={!beneficiaryJourney}
              />
              <JourneyCard
                cardName="recently-registered"
                counter={(beneficiaryJourney && beneficiaryJourney?.recentes) || 0}
                description="Cadastrados recentemente"
                isLoading={!beneficiaryJourney}
              />
              <JourneyCard
                cardName="prospecting"
                counter={(beneficiaryJourney && beneficiaryJourney?.prospeccao) || 0}
                description="Prospecção"
                isLoading={!beneficiaryJourney}
              />
              <JourneyCard
                cardName="nutrition"
                counter={(beneficiaryJourney && beneficiaryJourney?.nutricao) || 0}
                description="Nutrição"
                isLoading={!beneficiaryJourney}
              />
              <JourneyCard
                cardName="engaged"
                counter={(beneficiaryJourney && beneficiaryJourney?.engajamento) || 0}
                description="Engajados"
                isLoading={!beneficiaryJourney}
              />
              <JourneyCard
                cardName="with-collection"
                counter={(beneficiaryJourney && beneficiaryJourney?.coleta) || 0}
                description="Com coleta"
                isLoading={!beneficiaryJourney}
              />
              <JourneyCard
                cardName="with-schedule"
                counter={(beneficiaryJourney && beneficiaryJourney?.agendamento) || 0}
                description="Com agendamento"
                isLoading={!beneficiaryJourney}
              />
              <JourneyCard
                cardName="with-assistance"
                counter={(beneficiaryJourney && beneficiaryJourney?.atendimento) || 0}
                description="Com atendimento"
                isLoading={!beneficiaryJourney}
              />
            </div>
          </div>
        </div>
        <section className="project-summary__right-section__down">
          <CardHeader
            title={`${favoritedTestimonials ? `Destaques salvos (${testimonials?.length || 0})` : `Destaques do projeto (${testimonials?.length || 0})`}`}
            className="testimonials-header">
            <div className="testimonials-header__goTo" onClick={(e) => handleFavoritedTestimonials()}>
              {favoritedTestimonials ? <ButtonClose /> : <i className="fi fi-sr-angle-small-right" />}
            </div>
          </CardHeader>
          <div className="testimonials-list-container">
            <TestimonialsList
              data={testimonials}
              handleFavoriteTestimonial={handleFavoriteTestimonial}
              favoritedTestimonials={favoritedTestimonials}
              isLoading={isLoading || isRefetching}
              fetchNextPage={fetchNextPage}
              hasNextPage={hasNextPage}
              isFetchingNextPage={isFetchingNextPage}
              isFavoriteRefetching={isFavoriteRefetching}
              scopeId={projectId}
            />
          </div>
        </section>

        {openModal === "assistanceDetails" && (
          <ModalPanel modalIsOpen>
            <ModalHeader title="Atendimentos" closeModal={() => toggleModal(null)} line={false} />
            <ModalBody>
              <div className="modal-assistance-details">
                <div className="modal-assistance-details__chart ranking">
                  <span>Atendimentos realizados</span>
                  <div className="modal-assistance-details__chart-ranking">
                    <RankingChart data={assistanceDetails?.assistancesByQuestionGroup} />
                  </div>
                </div>
                <div className="modal-assistance-details__chart interaction">
                  <span>Nível de interação ou adoção do produtor em relação à recomendação</span>
                  <InteractionChart data={assistanceDetails?.levelOfInteraction} />
                </div>
              </div>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "end", width: "100%" }}>
                  <div className="container-flex">
                    <div className="filter-button-container" onClick={() => handleShowFilters()}>
                      <IoFilterOutline className="icon-filter" />
                      <text className="text-filter">Filtrar</text>
                    </div>
                    <div>
                      <ButtonLoader
                        label="Exportar"
                        handleClick={exportAssistance}
                        loading={loadingAssistanceTable}
                        messageProcess="Exportando..."
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="table-container">
                    <div className="table-header">
                      <div className="table-cell">Nome do produtor</div>
                      <div className="table-cell">Data do atendimento</div>
                      <div className="table-cell">Projeto</div>
                      <div className="table-cell">Técnico responsável</div>
                      <div className="table-cell">tipo de atendimento</div>
                      <div className="table-cell">Links</div>
                    </div>
                    <List
                      className="table-body"
                      height={300}
                      itemCount={allDetailsAssistances?.length ?? 0}
                      itemSize={getRowHeight}
                      width="100%">
                      {Row}
                    </List>

                  </div>
                </div>
              </div>
            </ModalBody>
          </ModalPanel>
        )}

        {openModal === "sharedContent" && [...contents, ...producers]?.length && (
          <ModalPanel modalIsOpen>
            <ModalHeader
              title="Conteúdos compartilhados com os beneficiários"
              closeModal={() => toggleModal(null)}
              line={false}
            />
            <ModalBody>
              <div className="modal-assistance-details">
                <div className="modal-producers-list">
                  <div className="bullet-tabs-period">
                    <BulletTabs options={tabs} onSelect={handleChangeTab} />
                    <div className="table-period-filter">
                      <div className="table-period-filter-date">
                        <PickerWithType
                          onChange={onFilterDate}
                          value={dateFilter || ""}
                          isWhite={false}
                        />
                      </div>
                      <ButtonLoader
                        label="Exportar"
                        handleClick={exportContent}
                        loading={loading}
                        messageProcess="Exportando..."
                      />
                    </div>
                  </div>
                  <div className="inside-modal-list">
                    {currentTab === "contents" && (
                      <div className="producer-list">
                        {contents?.length > 0 ? (
                          contents?.map((item, index) => <ContentListItem key={index} item={item} />)
                        ) : (
                          <div className="empty-list">
                            <h4>Sem dados para o filtro selecionado</h4>
                          </div>
                        )}
                      </div>
                    )}
                    {currentTab === "producers" && (
                      <div className="producer-list">
                        {producers?.length ? (
                          producers?.map((item, index) => (
                            <ProducerListItem key={index} item={item} />
                          ))
                        ) : (
                          <div className="empty-list">
                            <h4>Sem dados para o filtro selecionado</h4>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ModalBody>
          </ModalPanel>
        )}

        {openModal === "geolocalization" && (
          <ModalPanel modalIsOpen>
            <ModalHeader
              title="Geolocalização dos beneficiários"
              closeModal={() => toggleModal(null)}
              line={false}
            />
            <ModalBody className="modal-assistance-geolocalization">
              <div className="modal-assistance-details">
                <BurnedContainer onlyMap />
              </div>
            </ModalBody>
          </ModalPanel>
        )}

        {showFilters && (
          <AssistanceDetailsFilters
            {...{
              modalOpen: showFilters, setModalOpen: handleShowFilters,
              assistancesTypes,
              handleAssistancesDetailsFilters,
              assistancesDetailsFilters,
              projectsOptions,
              allDetailsAssistancesTechnicians,
              allDetailsAssistancesUsers,
              isUserTec
            }}
          />
        )}
      </div>
    </>
  )
}

export default ProjectSummaryScreen

const scaleData = [
  { details: { Conceito: "Ruim" } },
  { details: { Conceito: "Baixo" } },
  { details: { Conceito: "Médio" } },
  { details: { Conceito: "Bom" } },
  { details: { Conceito: "Alto" } },
]

const tabs = [
  { value: 1, label: "Conteúdos", type: "contents" },
  { value: 2, label: "Produtores", type: "producers" },
]

const AssistanceCard = ({ nameCard = "", className = "", children, info = "" }) => (
  <div className={`assistance-card ${nameCard} ${className}`}>
    {info !== "" && <InfoTooltip info={info} className="assistance-card-info" />}
    {children}
  </div>
)

const AssistanceCardContent = ({ title, subtitle, counterUser }) => (
  <div className="assistance-card-content">
    <div className="assistance-card-content-description">
      <div className="assistance-card-content-counter-users">
        <span className="assistance-card-content-description-title">{title}</span>
        {counterUser && counterUser !== 0 && (
          <div className="counter-users-icon-value">
            <i className="fi fi-sr-user"></i>
            <span className="assistance-card-content-description-subtitle">{counterUser}</span>
          </div>
        )}
      </div>
      <span className="assistance-card-content-description-subtitle">{subtitle}</span>
    </div>
  </div>
)

const CounterIcon = ({ children, className = "" }) => (
  <div className={`counter ${className}`}>
    <div className="counter-icon">{children}</div>
  </div>
)

const MetricHeaderCard = memo(({ isUserAdmin }) => {
  return (
    <>
      <div className="assistance-evaluation__cards-metrics">
        <CardHeader
          title="Métricas do Período"
          className={!isUserAdmin ? "metrics-tec-header" : ""}
        />
      </div>
    </>
  )
})

const HistoryChart = ({ data }) => {
  return (
    <div className="assistance-evaluation__cards assistance-evaluation__cards-history">
      <CardHeader className="evaluation-header">
        <span>Desempenho de atendimentos e mensagens nos últimos 6 meses</span>
      </CardHeader>
      <div className="assistance-evaluation__cards-notes">
        <ResponsiveContainer width="100%" height={300}>
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month">
              <Label value="Mês" offset={-5} position="insideBottom" />
            </XAxis>
            <YAxis yAxisId="left">
              <Label value="N.º Atendimentos" angle={-90} position="insideLeft" />
            </YAxis>
            <YAxis yAxisId="right" orientation="right">
              <Label value="N.º Mensagens" angle={90} position="insideRight" />
            </YAxis>
            <Tooltip />
            <Legend />
            <Bar
              yAxisId="left"
              dataKey="atendimentosRealizados"
              fill="#8884d8"
              name="Atendimentos Realizados"
            />
            <Bar
              yAxisId="left"
              dataKey="atendimentosAvaliados"
              fill="#82ca9d"
              name="Atendimentos Avaliados"
            />
            <Bar
              yAxisId="left"
              dataKey="atendimentosRetornados"
              fill="#ffc658"
              name="Atendimentos Retornados"
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="mensagensRecebidas"
              stroke="#ff7300"
              name="Mensagens Recebidas"
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="mensagensEnviadas"
              stroke="#387908"
              name="Mensagens Enviadas"
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

const MetricCard = ({ assistanceData, assistanceEvaluation, isUserAdmin, assistanceEvaluationHistory }) => {
  const totalAssistances = assistanceEvaluation
    ? (assistanceEvaluation.scheduleAssistances || 0) + (assistanceEvaluation.assistanceReturn || 0)
    : 0

  return (
    <div className="assistance-evaluation__cards">
      <MetricHeaderCard
        {...{
          isUserAdmin,
        }}
      />
      <EvaluationCard assistanceEvaluation={assistanceEvaluation} />
      <div className="last-assistance__section-counter">
        <div className="top-section">
          <CounterCard
            nameCard="finished"
            icon={<ChatIcon />}
            title={assistanceEvaluation && formatNumber(assistanceData?.finished?.length || 0)}
            subtitle="Atendimentos Realizados"
            className="larger-card"
          />
        </div>
        <div className="bottom-section">
          <CounterCard
            nameCard="schedule"
            icon={<i className="fi fi-sr-calendar" />}
            info="Atendimentos agendados por você"
            title={formatNumber(totalAssistances)}
            subtitle="Atendimentos Agendados"
          />
          <CounterCard
            nameCard="evaluated"
            icon={<i className="fi fi-sr-star" />}
            title={assistanceEvaluation && formatNumber(assistanceEvaluation?.evaluated_assistance)}
            subtitle="Atendimentos Avaliados"
          />
          <CounterCard
            nameCard="received-messages"
            info="Quantidade de mensagens recebidas por beneficiários no projeto (beneficiários excluídos não inclusos)"
            icon={<i className="fi fi-sr-comments" />}
            title={assistanceEvaluation && formatNumber(assistanceEvaluation?.received_messages)}
            counterUser={
              assistanceEvaluation && formatNumber(assistanceEvaluation?.received_users_messages)
            }
            subtitle="Mensagens Recebidas"
          />
          <CounterCard
            nameCard="send-messages"
            info="Quantidade de mensagens enviadas para beneficiários no projeto (beneficiários excluídos não inclusos)"
            icon={<i className="fi fi-sr-comment-user" />}
            title={assistanceEvaluation && formatNumber(assistanceEvaluation?.messages_sent)}
            counterUser={
              assistanceEvaluation && formatNumber(assistanceEvaluation?.messages_users_sent)
            }
            subtitle="Mensagens Enviadas"
          />
        </div>
      </div>
      <HistoryChart data={assistanceEvaluationHistory} />
    </div>
  )
}

const CounterCard = ({ nameCard, icon, title, subtitle, info = "", counterUser, className }) => (
  <AssistanceCard nameCard={nameCard} info={info} className={`counter-card ${className || ""}`}>
    <CounterIcon className={nameCard}>{icon}</CounterIcon>
    <AssistanceCardContent title={title} subtitle={subtitle} counterUser={counterUser} />
  </AssistanceCard>
)
